
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle, RefreshCw, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface StaffErrorProps {
  error: string;
}

const StaffError: React.FC<StaffErrorProps> = ({ error }) => {
  const navigate = useNavigate();
  
  const handleRetry = () => {
    window.location.reload();
  };
  
  return (
    <Card className="border-red-200 max-w-lg mx-auto">
      <CardContent className="pt-6">
        <Alert variant="destructive" className="mb-4">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Error Loading Staff</AlertTitle>
          <AlertDescription>
            {error || "We encountered an issue while loading your AI staff data. Please try again."}
          </AlertDescription>
        </Alert>
        
        <p className="text-sm text-muted-foreground mt-4">
          This could be due to a temporary server issue or network problem. You can try refreshing 
          the page or return to the dashboard.
        </p>
      </CardContent>
      
      <CardFooter className="flex justify-between border-t p-4 gap-2">
        <Button 
          variant="outline" 
          onClick={() => navigate('/app/dashboard')}
          className="gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Dashboard
        </Button>
        
        <Button 
          onClick={handleRetry}
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Retry
        </Button>
      </CardFooter>
    </Card>
  );
};

export default StaffError;
